<template>
  <h1 class="ma-2">Welcome!</h1>
</template>

<script>
export default {
  props: {
    source: String
  },
  data: () => ({
    drawer: null
  })
}
</script>
